module.exports = __webpack_public_path__ + "assets/6e04a1a81c9bd6607f4588c7b3bad75f.png";